module.exports = __webpack_public_path__ + "static/img/MQ.d56d94f6.svg";